import { render, staticRenderFns } from "./CountryNudgeBanner.vue?vue&type=template&id=4005fbe8&scoped=true&lang=pug&"
import script from "./CountryNudgeBanner.vue?vue&type=script&lang=js&"
export * from "./CountryNudgeBanner.vue?vue&type=script&lang=js&"
import style0 from "./CountryNudgeBanner.vue?vue&type=style&index=0&id=4005fbe8&scoped=true&lang=css&"
import style1 from "./CountryNudgeBanner.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4005fbe8",
  null
  
)

export default component.exports